import * as React from 'react';
import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { ApplicationState } from '../store';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Store from './store/WidgetSettingsStore';
import ViewHeaderBar from '../components/ViewHeaderBar';
import { localizations } from '../localization/localization';
import * as LoginStore from '../login/loginStore';
import widgetImg from '../images/logos/screenCaptures/widget.png';

const styles = (theme: Theme) => ({
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    icon: {
        height: "16px",
        widht: "16px"
    }
});
type WithStylesProps = "leftIcon";
type WidgetSettingsProps = 
    WithStyles<WithStylesProps> &
    { widgetSettingsActions: typeof Store.actionCreators} &
    { widgetSettings: Store.WidgetSettingsState, login: LoginStore.LoginState } &
    { apiKey: string } &
    typeof Store.actionCreators & WithStyles<"icon">;

interface WidgetSettingsViewState {
    apiKey: string;
}

class WidgetSettingsView extends React.Component<WidgetSettingsProps, WidgetSettingsViewState> {

    constructor(props: WidgetSettingsProps) {
        super(props);
        this.generateApiKey = this.generateApiKey.bind(this);
    }

    public componentDidMount(){
      this.props.widgetSettingsActions.RequestTestPartnerApiKey();
    }

    public render() {
        return (
            <React.Fragment>
                <ViewHeaderBar titleVariant="h6" title={localizations.settings.widgetAndApiSettings}/>
                <Typography variant="h6" gutterBottom>{localizations.landingPageView.newFeatures.title5}</Typography>
                <div>
                    <Typography paragraph>
                        {localizations.settings.widgetInstructions}
                    </Typography>
                </div>
                <div>
                    <img alt="Widget" src={widgetImg} />
                </div>
                <div>
                    <Button variant="contained" color="secondary" onClick={() => this.generateApiKey()}>
                        {localizations.settings.generateApiKey}
                    </Button>
                </div>
                <div>
                    <TextField multiline fullWidth margin="normal" value={`<div id=\"unit-widget\" companyApiKey=\"${this.props.apiKey ?? ''}\">` +
                        `<script src=\"https://unitspotter.fi/widgets/unit-widget.js\"></script>`}/>
                </div>
                <Typography variant="h6" gutterBottom>{localizations.landingPageView.newFeatures.title6}</Typography>
                <Typography paragraph>{localizations.settings.partnerApiDescription}</Typography>
                <Typography>{localizations.settings.partnerApiContainsFollowingFeatures}:</Typography>
                <ul>
                    <li><Typography>{localizations.settings.getUnits} (GET)</Typography></li>
                    <li><Typography>{localizations.settings.getTrucks} (GET)</Typography></li>
                    <li><Typography>{localizations.settings.createUnit} (POST)</Typography></li>
                    <li><Typography>{localizations.settings.createTruck} (POST)</Typography></li>
                    <li><Typography>{localizations.settings.deleteUnit} (DELETE)</Typography></li>
                    <li><Typography>{localizations.settings.deleteTruck} (DELETE)</Typography></li>
                    <li><Typography>{localizations.settings.updateUnit} (PUT)</Typography></li>
                    <li><Typography>{localizations.settings.updateTruck} (PUT)</Typography></li>
                </ul>
                <Typography paragraph>
                  {localizations.settings.partnerApiAuthenticationDescription}
                </Typography>
                <Typography paragraph>
                  <Link
                    href="https://hangonsatama-nuppiappi-qa-api.azurewebsites.net/swagger"
                    target="_blank"
                    rel="noopener"
                  >
                    {localizations.settings.partnerApiInstructions}
                  </Link>
                  {` ${localizations.settings.partnerApiTestKey}: ${this.props.widgetSettings.partnerApiSettings.data?.testPartnerApiKey ?? ''}`}
                </Typography>
                <Typography paragraph>{localizations.settings.partnerApiTestEmailInfo}</Typography>
                <Typography>{localizations.settings.partnerApiContactInfo} {localizations.settings.partnerApiDevelopmentNotice}</Typography>
            </React.Fragment>
            );
    }

    private generateApiKey() {
        this.props.widgetSettingsActions.RequestGenerateApiKey();
    }
}

const mapStateToProps = (state: ApplicationState, dispatch: any) => {
    const { login, widgetSettings } = state;

    return { 
        login, widgetSettings
     };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        widgetSettingsActions: bindActionCreators(Store.actionCreators, dispatch)
    }
}

export default withStyles(styles)(connect<any, any, any>(mapStateToProps, mapDispatchToProps)(WidgetSettingsView));


// WEBPACK FOOTER //
// ./src/account/WidgetSettingsView.tsx